"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var lodash_1 = require("lodash");
var constants_1 = require("../Player/components/FeaturedProductsContainer/constants");
var product_1 = __importDefault(require("../Player/components/FeaturedProductsContainer/product"));
var ProductDetails_1 = __importDefault(require("./components/ProductDetails"));
var VariantRadio_1 = __importDefault(require("./components/VariantRadio"));
var VariantSelect_1 = __importDefault(require("./components/VariantSelect"));
var Shopify_1 = __importDefault(require("./Shopify"));
var constants_2 = require("./components/ProductDetails/constants");
var constants_3 = require("./constants");
var FeaturedProductsContainer_1 = require("../Player/components/FeaturedProductsContainer");
var BagButton_1 = __importDefault(require("./components/BagButton"));
var Bag_1 = __importDefault(require("./components/Bag"));
var splitShopifyId_1 = require("../../utils/splitShopifyId");
var getLineItemCount_1 = require("../../utils/getLineItemCount");
var FeaturedProducts = /** @class */ (function () {
    function FeaturedProducts(_a) {
        var playerContainerElement = _a.playerContainerElement, featuredProductsContainerElement = _a.featuredProductsContainerElement, products = _a.products, shopifyStoreDetails = _a.shopifyStoreDetails;
        var _this = this;
        this.handleBagButtonClick = function () {
            _this.isBagOpen = !_this.isBagOpen;
            if (_this.isBagOpen) {
                _this.onBagOpen();
            }
            else {
                _this.onBagClose();
            }
        };
        this.onProductFormSubmit = function (event) { return __awaiter(_this, void 0, void 0, function () {
            var orderDetailsForm, ErrorMesssageElement, formData, cart;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        orderDetailsForm = (document.querySelector("form[name=\"".concat(constants_3.PRODUCT_DETAILS_FORM_NAME, "\"]")));
                        ErrorMesssageElement = (orderDetailsForm.querySelector('.error-message'));
                        event.preventDefault();
                        formData = new FormData(event.target);
                        this.selectedVariantOptions = {
                            quantity: (0, lodash_1.parseInt)(formData.get(constants_2.QUANTITY_SELECTOR_NAME)),
                        };
                        if (!ErrorMesssageElement.hidden) {
                            ErrorMesssageElement.hidden = true;
                        }
                        (0, lodash_1.forEach)(this.variantDetails, function (_a) {
                            var _b;
                            var name = _a.name;
                            var value = formData.get("".concat(name).concat(constants_3.VARIANT_SELECTOR_NAME_SUFFIX));
                            if (value) {
                                _this.selectedVariantOptions = __assign(__assign({}, _this.selectedVariantOptions), (_b = {}, _b[name] = value, _b));
                            }
                            else {
                                ErrorMesssageElement.hidden = false;
                            }
                        });
                        if (!ErrorMesssageElement.hidden) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.shopifyInstance.addProductToBag({
                                product: this.productDetails,
                                variantOptions: this.selectedVariantOptions,
                            })];
                    case 1:
                        cart = _a.sent();
                        this.updateBagButtonElement((0, getLineItemCount_1.getItemCount)(cart.lines.edges));
                        this.onCloseProductDetails();
                        _a.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        }); };
        // Handles the change event for the variant options
        this.handleVariantChange = function (event) {
            var _a;
            var _b = event.target, selectorName = _b.name, value = _b.value;
            var _c = event.target.dataset, name = _c.type, targetIndex = _c.index;
            // When a variant option is changed, update the selected variant options
            _this.selectedVariantOptions = __assign(__assign({}, _this.selectedVariantOptions), (_a = {}, _a[name] = value, _a));
            // Update all of the other selectors disabled status based on the new selected options
            var variantSelectors = document.querySelectorAll('.variant-select');
            var filteredSelectors = (0, lodash_1.filter)(variantSelectors, function (selector) { return selector.name !== selectorName; });
            (0, lodash_1.forEach)(filteredSelectors, function (selector) {
                var _a;
                var _b = selector.dataset, nextIndex = _b.index, nextSelectorName = _b.type, nextSelectorType = _b.selectorType;
                if (nextIndex > targetIndex) {
                    if (nextSelectorType === 'select') {
                        var options = selector.options;
                        for (var i = 0; i < options.length; i++) {
                            var option = options[i];
                            var isDisabled = _this.getDisabledStatus({
                                index: (0, lodash_1.toNumber)(nextIndex),
                                name: nextSelectorName,
                                value: option.value,
                            });
                            option.disabled = isDisabled;
                            if (isDisabled) {
                                if (option.selected) {
                                    option.selected = false;
                                    _this.selectedVariantOptions = (0, lodash_1.omit)(_this.selectedVariantOptions, [nextSelectorName]);
                                    // set the first available option as selected
                                    // This is necessary as event listeners are not triggered when setting the value programmatically
                                    var firstAvailableOption = (0, lodash_1.find)(_this.mappedVariantOptions, function (option) { return option.name === nextSelectorName; });
                                    if (firstAvailableOption) {
                                        _this.selectedVariantOptions = __assign(__assign({}, _this.selectedVariantOptions), (_a = {}, _a[nextSelectorName] = (0, lodash_1.first)(firstAvailableOption.values)
                                            .value, _a));
                                    }
                                }
                            }
                        }
                    }
                    else {
                        var nextSelectorValue = selector.value;
                        var isDisabled = _this.getDisabledStatus({
                            index: (0, lodash_1.toNumber)(nextIndex),
                            name: nextSelectorName,
                            value: nextSelectorValue,
                        });
                        selector.disabled = isDisabled;
                        if (isDisabled) {
                            if (selector.checked) {
                                selector.checked = false;
                                _this.selectedVariantOptions = (0, lodash_1.omit)(_this.selectedVariantOptions, [
                                    nextSelectorName,
                                ]);
                            }
                        }
                    }
                }
            });
            // Updates the add to cart button disabled status based on the number of selected options
            var updatedSelectedOptions = (0, lodash_1.omit)(_this.selectedVariantOptions, [
                'quantity',
            ]);
            var addToCartButton = document.querySelector('#add-to-cart-button');
            if (addToCartButton) {
                addToCartButton.disabled =
                    (0, lodash_1.size)(updatedSelectedOptions) < (0, lodash_1.size)(_this.variantDetails);
            }
        };
        this.getDisabledStatus = function (_a) {
            var _b;
            var index = _a.index, value = _a.value, name = _a.name;
            // Check if the current option is available based on the mapped variant options
            if (index === 0) {
                var currentOption = (0, lodash_1.find)(_this.mappedVariantOptions, { name: name });
                if (currentOption) {
                    var currentOptionValue = (0, lodash_1.find)(currentOption.values, { value: value });
                    if (currentOptionValue) {
                        return !currentOptionValue.isAvailable;
                    }
                }
            }
            if (index > 0) {
                // depending on the index of the selector, go through mapped variant options and check if the option is available deep in the child options
                var firstOption = (0, lodash_1.first)(_this.mappedVariantOptions);
                if (firstOption) {
                    // Using the index, find the current option inside the first option and check if it is available
                    var selectedValue = _this.selectedVariantOptions[firstOption.name];
                    var currentOption = (0, lodash_1.find)(firstOption.values, {
                        value: selectedValue,
                    });
                    if (currentOption) {
                        // If the current option is available, keep going deeper till you find the right child options that match the selected values
                        var childOption = (0, lodash_1.find)(currentOption.childOptions[name], { value: value });
                        if (childOption) {
                            return !childOption.isAvailable;
                        }
                        else {
                            // if the child option is not in the next level of the child options, we need to go deeper based off of the previous index
                            var previousCurrentOptionName = _this.variantDetails[index - 1]
                                .name;
                            var previousSelectedValue = _this.selectedVariantOptions[previousCurrentOptionName];
                            var selectedChildOption = (0, lodash_1.find)(currentOption.childOptions[previousCurrentOptionName], { value: previousSelectedValue });
                            if (selectedChildOption) {
                                var childOptions = selectedChildOption.childOptions;
                                return childOptions[name]
                                    ? !((_b = (0, lodash_1.find)(childOptions[name], { value: value })) === null || _b === void 0 ? void 0 : _b.isAvailable)
                                    : true;
                            }
                        }
                    }
                }
            }
            return false;
        };
        this.onCloseProductDetails = function () {
            if (!(0, lodash_1.isNil)(_this.textContainerElement)) {
                _this.textContainerElement.innerHTML = (0, FeaturedProductsContainer_1.renderButtonText)();
            }
            document.querySelector(".".concat(constants_2.PRODUCT_DETAILS_CLASS)).remove();
            document.getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID).hidden = false;
        };
        this.playerContainerElement = playerContainerElement;
        this.featuredProductsContainerElement = featuredProductsContainerElement;
        this.shopifyStoreDetails = shopifyStoreDetails;
        this.textContainerElement = document.querySelector(".".concat(constants_3.PRODUCTS_TOGGLE_TEXT_CLASS));
        this.isBagOpen = false;
        this.hasBagButtonRendered = false;
        this.firstAvailableOptions = {};
        this.products = [];
        this.updateProducts(products);
    }
    FeaturedProducts.prototype.updateFeaturedProductsContainerElement = function (featuredProductsContainerElement) {
        this.featuredProductsContainerElement = featuredProductsContainerElement;
        featuredProductsContainerElement.querySelector("#".concat(constants_1.PRODUCT_LIST_ELEMENT_ID)).innerHTML = '';
        this.products = [];
    };
    FeaturedProducts.prototype.changeContainerHiddenState = function (productList) {
        if ((0, lodash_1.isEmpty)(productList) && !this.featuredProductsContainerElement.hidden) {
            this.featuredProductsContainerElement.hidden = true;
        }
        else if (!(0, lodash_1.isEmpty)(productList) &&
            this.featuredProductsContainerElement.hidden) {
            this.featuredProductsContainerElement.hidden = false;
        }
    };
    FeaturedProducts.prototype.updateProducts = function (featuredProductsUpdate) {
        var _this = this;
        this.changeContainerHiddenState(featuredProductsUpdate);
        var unfeaturedProducts = (0, lodash_1.differenceBy)(this.products, featuredProductsUpdate, 'product.id');
        var newFeaturedProducts = (0, lodash_1.differenceBy)(featuredProductsUpdate, this.products, 'product.id');
        (0, lodash_1.forEach)(unfeaturedProducts, function (_a) {
            var unfeaturedProduct = _a.product;
            _this.removeProduct(unfeaturedProduct);
        });
        if (!(0, lodash_1.isEmpty)(newFeaturedProducts)) {
            this.renderProducts(newFeaturedProducts);
        }
        this.products = featuredProductsUpdate;
    };
    FeaturedProducts.prototype.renderProducts = function (productList) {
        var _this = this;
        (0, lodash_1.forEach)(productList, function (_a) {
            var product = _a.product;
            _this.renderProduct(product);
        });
    };
    FeaturedProducts.prototype.renderProduct = function (product) {
        if ((0, lodash_1.isEqual)(product.product_type, 'shopify') &&
            !(0, lodash_1.isEmpty)(this.shopifyStoreDetails) &&
            !(0, lodash_1.isEmpty)(this.shopifyStoreDetails.storefrontAccessToken)) {
            this.renderShopifyProduct(product);
        }
        else {
            this.renderLiveProduct(product);
        }
    };
    FeaturedProducts.prototype.renderLiveProduct = function (product) {
        document
            .getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID)
            .insertAdjacentHTML('afterbegin', (0, product_1.default)({ product: product, useUrl: true }));
    };
    FeaturedProducts.prototype.renderBag = function (cart) {
        return __awaiter(this, void 0, void 0, function () {
            var fetchedCart, _a, BAG_ELEMENT;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = cart;
                        if (_a) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.shopifyInstance.getCart()];
                    case 1:
                        _a = (_b.sent());
                        _b.label = 2;
                    case 2:
                        fetchedCart = _a;
                        BAG_ELEMENT = this.featuredProductsContainerElement.querySelector(".".concat(constants_3.SHOPIFY_BAG_CLASS));
                        if (BAG_ELEMENT) {
                            BAG_ELEMENT.remove();
                        }
                        this.featuredProductsContainerElement.insertAdjacentHTML('beforeend', (0, Bag_1.default)(fetchedCart));
                        this.featuredProductsContainerElement.classList.add(constants_3.BAG_OPEN_CLASS);
                        this.featuredProductsContainerElement
                            .querySelector(".".concat(constants_3.SHOPIFY_BAG_CLASS, " .").concat(constants_3.SHOPIFY_BAG_BACK_BUTTON_CLASS))
                            .addEventListener('click', this.handleBagButtonClick);
                        (0, lodash_1.forEach)(fetchedCart.lines.edges, function (_a) {
                            var node = _a.node;
                            var nodeId = node.id, merchandise = node.merchandise;
                            var productVariantId = merchandise.id;
                            var elementId = (0, splitShopifyId_1.splitShopifyId)(productVariantId).id;
                            document
                                .getElementById(elementId)
                                .querySelector(".".concat(constants_3.REMOVE_ITEM_BUTTON_CLASS))
                                .addEventListener('click', function () {
                                _this.onRemoveLineItem(nodeId);
                            });
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FeaturedProducts.prototype.onRemoveLineItem = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var cart;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.shopifyInstance.deleteCheckoutLineItem(id)];
                    case 1:
                        cart = _a.sent();
                        return [4 /*yield*/, this.renderBag(cart)];
                    case 2:
                        _a.sent();
                        this.updateBagButtonElement((0, getLineItemCount_1.getItemCount)(cart.lines.edges));
                        return [2 /*return*/];
                }
            });
        });
    };
    FeaturedProducts.prototype.onBagOpen = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ProductDetailsElement;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        ProductDetailsElement = this.featuredProductsContainerElement.querySelector(".".concat(constants_2.PRODUCT_DETAILS_CLASS));
                        if ((0, lodash_1.isEmpty)(this.shopifyInstance)) {
                            this.shopifyInstance = new Shopify_1.default(this.shopifyStoreDetails);
                        }
                        return [4 /*yield*/, this.renderBag()];
                    case 1:
                        _a.sent();
                        if (!(0, lodash_1.isNil)(this.textContainerElement)) {
                            this.textContainerElement.innerHTML = (0, FeaturedProductsContainer_1.renderButtonText)('Shopping Cart');
                        }
                        document.getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID).hidden = true;
                        if (!(0, lodash_1.isNil)(ProductDetailsElement)) {
                            ProductDetailsElement.remove();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FeaturedProducts.prototype.onBagClose = function () {
        this.featuredProductsContainerElement
            .querySelector(".".concat(constants_3.SHOPIFY_BAG_CLASS))
            .remove();
        this.featuredProductsContainerElement.classList.remove(constants_3.BAG_OPEN_CLASS);
        if (!(0, lodash_1.isNil)(this.textContainerElement)) {
            this.textContainerElement.innerHTML = (0, FeaturedProductsContainer_1.renderButtonText)();
        }
        document.getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID).hidden = false;
    };
    FeaturedProducts.prototype.renderBagButton = function () {
        var LastControlElement = this.playerContainerElement.querySelector('.vjs-control-bar > :last-child');
        if (!(0, lodash_1.isNil)(LastControlElement)) {
            LastControlElement.insertAdjacentHTML('beforebegin', (0, BagButton_1.default)());
            this.playerContainerElement
                .querySelector(".".concat(constants_3.SHOPIFY_BAG_BUTTON_CLASS))
                .addEventListener('click', this.handleBagButtonClick);
            this.hasBagButtonRendered = true;
        }
    };
    FeaturedProducts.prototype.renderShopifyProduct = function (product) {
        var _this = this;
        if (!this.hasBagButtonRendered) {
            this.renderBagButton();
        }
        document
            .getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID)
            .insertAdjacentHTML('afterbegin', (0, product_1.default)({ product: product }));
        document
            .getElementById("product-".concat(product.id))
            .addEventListener('click', function () {
            _this.openShopifyProductDetails(product);
        });
    };
    FeaturedProducts.prototype.removeProduct = function (unfeaturedProduct) {
        var productElement = document.getElementById("product-".concat(unfeaturedProduct.id));
        if (!(0, lodash_1.isNil)(productElement)) {
            productElement.remove();
        }
    };
    FeaturedProducts.prototype.updateBagButtonElement = function (itemsInBag) {
        var CurrentBagButtonElement = this.playerContainerElement.querySelector(".".concat(constants_3.SHOPIFY_BAG_BUTTON_CLASS));
        if (CurrentBagButtonElement) {
            CurrentBagButtonElement.remove();
        }
        this.playerContainerElement
            .querySelector('.vjs-control-bar > :last-child')
            .insertAdjacentHTML('beforebegin', (0, BagButton_1.default)(itemsInBag));
        this.playerContainerElement
            .querySelector(".".concat(constants_3.SHOPIFY_BAG_BUTTON_CLASS))
            .addEventListener('click', this.handleBagButtonClick);
    };
    FeaturedProducts.prototype.openShopifyProductDetails = function (product) {
        return __awaiter(this, void 0, void 0, function () {
            var externalId, title, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        externalId = product.external_id, title = product.title;
                        if ((0, lodash_1.isEmpty)(this.shopifyInstance)) {
                            this.shopifyInstance = new Shopify_1.default(this.shopifyStoreDetails);
                        }
                        _a = this;
                        return [4 /*yield*/, this.shopifyInstance.getProduct(externalId)];
                    case 1:
                        _a.productDetails = _b.sent();
                        if (!(0, lodash_1.isNil)(this.productDetails)) {
                            if (!(0, lodash_1.isNil)(this.textContainerElement)) {
                                this.textContainerElement.innerHTML = (0, FeaturedProductsContainer_1.renderButtonText)(title);
                            }
                            document.getElementById(constants_1.PRODUCT_LIST_ELEMENT_ID).hidden = true;
                            this.featuredProductsContainerElement.insertAdjacentHTML('beforeend', (0, ProductDetails_1.default)(product, !this.productDetails.availableForSale));
                            document
                                .querySelector(".".concat(constants_2.PRODUCT_DETAILS_CLASS, " .close-button"))
                                .addEventListener('click', this.onCloseProductDetails);
                            if (this.productDetails.availableForSale) {
                                this.renderShopifyVariantSelectors(this.productDetails);
                                document
                                    .querySelector("form[name=\"".concat(constants_3.PRODUCT_DETAILS_FORM_NAME, "\"]"))
                                    .addEventListener('submit', this.onProductFormSubmit);
                            }
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    FeaturedProducts.prototype.renderShopifyVariantSelectors = function (productDetails) {
        return __awaiter(this, void 0, void 0, function () {
            var options, variants, variantOptions, cheapestAvailableOptions, _a;
            var _this = this;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        options = productDetails.options, variants = productDetails.variants;
                        variantOptions = (0, lodash_1.filter)(options, function (_a) {
                            var name = _a.name, values = _a.values;
                            var isDefaultName = (0, lodash_1.isEqual)(name, 'Title');
                            var isDefaultValue = (0, lodash_1.isEqual)(values[0].value, 'Default Title');
                            return !(isDefaultName && isDefaultValue);
                        });
                        cheapestAvailableOptions = ((0, lodash_1.first)((0, lodash_1.sortBy)((0, lodash_1.filter)(variants.nodes, 'availableForSale'), 'price')) || {}).selectedOptions;
                        this.selectedVariantOptions = (0, lodash_1.reduce)(variantOptions, function (prevValues, _a) {
                            var _b;
                            var name = _a.name;
                            return (__assign(__assign({}, prevValues), (_b = {}, _b[name] = (0, lodash_1.isNil)(cheapestAvailableOptions)
                                ? ''
                                : (0, lodash_1.find)(cheapestAvailableOptions, { name: name }).value, _b)));
                        }, this.selectedVariantOptions || {});
                        this.variantDetails = variantOptions;
                        _a = this;
                        return [4 /*yield*/, this.getVariantOptions(variantOptions, variants.nodes)];
                    case 1:
                        _a.mappedVariantOptions = _b.sent();
                        (0, lodash_1.forEach)(this.variantDetails, function (variant, index) {
                            _this.renderShopifyVariant(variant, index);
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    FeaturedProducts.prototype.getVariantOptions = function (variantOptions, variants) {
        // loop through the variants and map all variant options to the variant whether they are available or not.
        var mappedVariantOptions = (0, lodash_1.map)(variantOptions, function (_a) {
            var name = _a.name, values = _a.values;
            var mappedValues = (0, lodash_1.map)(values, function (value) {
                var childOptions = {};
                (0, lodash_1.forEach)(variants, function (variant) {
                    var selectedOption = (0, lodash_1.find)(variant.selectedOptions, { name: name, value: value });
                    if (selectedOption) {
                        var currentChildOptions_1 = childOptions;
                        (0, lodash_1.forEach)(variant.selectedOptions, function (_a) {
                            var childName = _a.name, childValue = _a.value;
                            if (childName !== name) {
                                if (!currentChildOptions_1[childName]) {
                                    currentChildOptions_1[childName] = [];
                                }
                                var existingOption = (0, lodash_1.find)(currentChildOptions_1[childName], {
                                    value: childValue,
                                });
                                if (!existingOption) {
                                    currentChildOptions_1[childName].push({
                                        value: childValue,
                                        isAvailable: variant.availableForSale,
                                        childOptions: {},
                                    });
                                }
                                currentChildOptions_1 = (0, lodash_1.find)(currentChildOptions_1[childName], {
                                    value: childValue,
                                }).childOptions;
                            }
                        });
                    }
                });
                return {
                    value: value,
                    isAvailable: (0, lodash_1.some)(variants, function (variant) {
                        return (0, lodash_1.find)(variant.selectedOptions, { name: name, value: value }) &&
                            variant.availableForSale;
                    }),
                    childOptions: childOptions,
                };
            });
            return {
                name: name,
                values: mappedValues,
            };
        });
        return mappedVariantOptions;
    };
    FeaturedProducts.prototype.renderShopifyVariant = function (_a, index) {
        var name = _a.name, values = _a.values;
        var RenderElement = (0, lodash_1.isEqual)(name.toLowerCase(), 'size')
            ? VariantRadio_1.default
            : VariantSelect_1.default;
        document
            .querySelector(".".concat(constants_3.VARIANT_SELECTORS_CONTAINER))
            .insertAdjacentHTML('beforeend', RenderElement({
            name: name,
            values: values,
            index: index,
            getDisabledStatus: this.getDisabledStatus,
            selectedVariantOptions: this.selectedVariantOptions,
            firstAvailableOptions: this.firstAvailableOptions,
        }));
        var variantSelectors = document.querySelectorAll(".variant-select[name=\"".concat(name).concat(constants_3.VARIANT_SELECTOR_NAME_SUFFIX, "\"]"));
        for (var i = 0; i < variantSelectors.length; i++) {
            variantSelectors[i].addEventListener('change', this.handleVariantChange);
        }
    };
    return FeaturedProducts;
}());
exports.default = FeaturedProducts;
